import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export const useSimulateStyles = makeStyles({
    table: {
        minWidth: 700,
        fontFamily: "OpenSans",
        fontSize: "0.8rem"
    },
    name: {
        fontFamily: "OpenSans",
        fontWeight: 600
    },
    divider: {
        borderLeft: "1px solid",
        margin: "3px 7px",
        height: 15
    },
    text: {
        fontFamily: "OpenSans",
        fontSize: "0.75rem",
        color: "#999",
        alignItems: "center"
    },
    textBold: {
        marginLeft: 3,
        fontWeight: 600
    },
    button: {
        '&:hover': {
            backgroundColor: "rgba(29, 141, 12, 1)"
        },
        '&.Mui-disabled': {
            backgroundColor: "rgba(38, 184, 16, 0.5)"
        },
        backgroundColor: "rgba(38, 184, 16, 1)"
    },
    button1: {
        '&:hover': {
            backgroundColor: "rgba(19, 88, 7, 1)"
        },
        '&.Mui-disabled': {
            backgroundColor: "rgba(38, 184, 16, 0.5)"
        },
        backgroundColor: "rgba(19, 88, 7, 1)"
    },
    tableCont: {
        // marginTop: "20px !important",
        maxHeight: "calc(50vh - 180px)",
        width: "calc(100% - 20px) !important",
        margin: "0px !important",
        maxWidth: "100% !important",
        padding: 10,
        borderRadius: "0px 0px 4px 4px"
    },
    tableCont1: {
        // marginTop: "20px !important",
        maxHeight: "calc(50vh - 180px)",
        margin: "0px !important",
        width: "auto !important",
        maxWidth: "calc(100% - 20px) !important",
        padding: 10,
        borderRadius: "0px 0px 4px 4px",
        display: "inline-flex"
    },
    nameCont: {
        fontFamily: "OpenSans",
        boxShadow: "rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px"
    },
    tableCell: {
        padding: "0px !important",
        whiteSpace: "nowrap",
        fontSize: "0.8rem"
    }
});

export const BodyTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        border: "1px solid #dde6ed",
        fontFamily: "OpenSansBold",
        fontSize: "0.8rem !important",
        whiteSpace: "nowrap"
    },
    body: {
        fontSize: 14,
        border: "1px solid #dde6ed",
    },
}))(TableCell);

export const BodyTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#f5f9fc",
        },
        '&:nth-of-type(even)': {
            backgroundColor: "#fff",
        }
    },
}))(TableRow);